<template>
  <div class="container_box">
    <div class="bg">
      <img src="../assets/imgs/banner1-1.png" alt="" />
    </div>
    <div class="content">
      <!-- 竞价大厅标题 -->
      <div class="flex between mb-20 pt-15">
        <div class="bold9 size20 color1">
          竞价列表
          <!-- <span style="font-size: 14px; color: #ccd9e9"
            >Bidding Hall</span
          > -->
        </div>
        <div class="color-aaa color2" style="margin-top: 4px">
          共有{{ total }}条竞价
        </div>
      </div>
      <!-- 搜索条件 -->
      <div class="px-15 pt-25 border-box mb-20 bg-color">
        <el-form label-width="70px" class="flex between flex-wrap">
          <div class="flex flex-wrap">
            <el-form-item label="竞价标题:">
              <el-input
                v-model="queryInfo.title"
                style="width: 150px"
                placeholder="请输入竞价标题"
              ></el-input>
            </el-form-item>
            <el-form-item label="参与方式:">
              <el-select
                v-model="queryInfo.participationMode"
                style="width: 100px; margin-right: 20px"
              >
                <el-option value="1" label="公开">公开</el-option>
                <el-option value="2" label="非公开">非公开</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label-width="90px" label="报名截至时间:">
              <el-date-picker
                @change="dateChange"
                v-model="dateRanger"
                class="datePicker"
                style="width: 220px"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                clearable
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="发起单位:" class="ml-20">
              <el-input
                v-model="queryInfo.publishCompany"
                style="width: 150px"
                placeholder="请输入发起单位"
              ></el-input>
            </el-form-item>
          </div>
          <div class="flex mb-15">
            <el-button
              @click="reset"
              class="buttonB"
              style="background-color: #95b3db"
              >重置</el-button
            >
            <el-button
              @click="getLieBiaoData"
              class="buttonB"
              style="background-color: #1c65c4"
              >搜索</el-button
            >
          </div>
        </el-form>
      </div>
      <!-- 表格 -->
      <el-table
        :header-cell-style="{
          background: '#3B426C',
          color: '#ffffff',
          padding: '0px',
          height: '40px',
        }"
        :cell-style="{ padding: '0px' }"
        :row-style="{ height: '40px' }"
        class="mb-10"
        :data="tableData"
        stripe
        style="font-size: 14px"
      >
        <el-table-column prop="lie1" label="参与方式" align="center">
          <template slot-scope="scope">
            {{ scope.row.participationMode == 1 ? "公开" : "非公开" }}
          </template>
        </el-table-column>
        <el-divider direction="vertical"></el-divider>
        <el-table-column prop="sessionNum" label="竞价编号" align="center">
        </el-table-column>
        <el-table-column
          prop="title"
          label="竞价标题"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="publishCompany"
          label="发起单位"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column prop="beginTime" label="报名截至时间" align="center">
          <!-- <template>
            <div>距离报名结束还有<span style="color: #ff0053">5</span>天</div>
          </template> -->
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            {{
              scope.row.status == 1
                ? "未开始"
                : scope.row.status == 2
                ? "准备中"
                : scope.row.status == 5
                ? "已结束"
                : "已开始"
            }}
          </template>
        </el-table-column>

        <el-table-column prop="lie6" label="操作" align="center">
          <template slot-scope="scope">
            <div>
              <div
                @click="goBaoMing(scope.row.id)"
                v-if="
                  scope.row.status == 1 && scope.row.participationStatus == 2
                "
                class="pointer"
              >
                我要参与
              </div>
              <div
                v-if="
                  scope.row.status == 1 && scope.row.participationStatus == 1
                "
                class="pointer"
              >
                未开始
              </div>
              <div
                v-if="scope.row.status == 5"
                class="pointer"
                @click="goDetail(scope.row)"
              >
                查看详情
              </div>
              <div
                @click="goXuZhi(scope.row)"
                v-if="
                  scope.row.status != 1 &&
                  scope.row.status != 5 &&
                  scope.row.participationStatus == 1
                "
                class="pointer"
              >
                我要竞价
              </div>
              <div
                @click="yiKaiShi(scope.row)"
                v-if="
                  scope.row.status != 1 &&
                  scope.row.status != 5 &&
                  scope.row.participationStatus == 2
                "
                class="pointer"
              >
                已开始
              </div>
            </div>
            <!-- <div v-else>
              <div
                @click="goLogin"
                v-if="scope.row.status == '1'"
                class="weikaishi pointer"
              >
                我要参与
              </div>
              <div @click="goLogin" v-else class="weikaishi pointer">
                查看详情
              </div>
            </div> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div
        v-if="tableData.length > 0"
        style="padding: 17px 50px 17px 0px"
        class="bg-color border-box"
      >
        <el-pagination
          class="pagination flex flex-end"
          prev-text="上一页"
          next-text="下一页"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          layout="prev,pager, next,slot"
          :total="total"
        >
          <div style="color: #ccd9e9; margin-left: 160px">
            到第
            <el-input
              v-model="queryInfo.pageNum"
              oninput="value=value.replace(/[^\d.]/g,'')"
            ></el-input
            >页/共{{ Math.ceil(total / queryInfo.pageSize) }}页
          </div>
          <div class="btn" @click="getLieBiaoData">确定</div>
        </el-pagination>
      </div>
    </div>

    <Footer class="mt-15" />
    <Result
      :title="resultTitle"
      :SubTitle="subTitle"
      :isShow="resultShow"
      @change="resultClose"
    />
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Result from "../components/Result.vue";

export default {
  components: { Footer, Result },
  data() {
    return {
      resultTitle: "",
      subTitle: "",
      resultShow: false,
      //表单数据
      queryInfo: {
        title: null,
        publishCompany: null, //发布单位
        participationMode: null, //参与方式
        beginBeginTime: null, //截止时间
        pageNum: 1,
        pageSize: 10,
        endBeginTime: null,
      },
      page: 1,
      message: "",
      //表格数据
      tableData: [],
      total: 0,
      userId: window.sessionStorage.getItem("userId"),
      dateRanger: "",
      keyWord: "",
    };
  },
  created() {
    // this.keyWord = window.sessionStorage.getItem("keyWords");
    window.addEventListener("setItem", (e) => {
      if (e.key == "keyWords" && e.newValue != "null") {
        this.keyWord = e.newValue;
      }
    });
    if (!this.keyWord) {
      this.getLieBiaoData();
    }
  },
  watch: {
    keyWord: {
      handler: function (val) {
        this.keyWord = val;
        if (this.keyWord) this.getSearchList();
      },
    },
  },
  mounted() {},

  methods: {
    resultClose() {
      this.resultShow = false;
    },
    //获取搜索列表
    async getSearchList() {
      const { data: res } = await this.$axios.get(
        "/api/biddingInfo/searchBiddingList",
        {
          params: {
            queryParam: this.keyWord,
          },
        }
      );
      if (res.code == 200) {
        this.resetSetItem("keyWords", null);

        // window.sessionStorage.clear("keyWords");

        this.total = res.total;
        this.tableData = res.data;
        // this.page = this.total / this.queryInfo.pageSize
        // this.page = parseInt(this.page>1?this.page:"1")
      } else {
        // this.$message.closeAll();
        // return this.$message.error(res.msg);
      }
    },
    dateChange(val) {
      this.queryInfo.beginBeginTime = val[0];
      this.queryInfo.endBeginTime = val[1];
    },
    //一开始
    yiKaiShi() {
      this.resultTitle = "竞价已经开始";
      this.subTitle = "竞价已经开始,如已报名,请到竞价大厅报价";
      this.resultShow = true;
      // this.$message.closeAll();
      // return this.$message.error("竞价已经开始");
      // window.sessionStorage.setItem("jjId", row.id);
      // this.$router.push("/jjxz");
    },
    //点击我要参与
    async goBaoMing(id) {
      window.sessionStorage.setItem("jjId", id);
      this.$router.push("/jjlbxq");
    },
    //没有登陆点击跳转登录
    goLogin() {
      // this.$message.closeAll();
      // this.$message.error("请先登录");
      this.resultTitle = "未登录";
      this.subTitle = "您未登录,请先登录";
      this.resultShow = true;
    },
    //获取列表页
    async getLieBiaoData() {
      this.queryInfo.pageNum = Number(this.queryInfo.pageNum);
      // let userId = window.sessionStorage.getItem("userId");
      // let url = "";
      // if (!userId) {
      //   userId = "";
      //   url = "/api/biddingInfo/getBiddingList";
      // } else {
      //   url = `/api/biddingInfo/getBiddingList/${userId}`;
      // }
      const { data: res } = await this.$axios({
        url: "/api/biddingInfo/getBiddingList",
        method: "get",

        params: {
          userId: window.sessionStorage.getItem("userId"),
          pageNum: this.queryInfo.pageNum,
          pageSize: this.queryInfo.pageSize,
          title: this.queryInfo.title,
          publishCompany: this.queryInfo.publishCompany,
          participationMode: this.queryInfo.participationMode,
          beginBeginTime: this.queryInfo.beginBeginTime,
          endBeginTime: this.queryInfo.endBeginTime,
        },
      });
      console.log(res);
      if (res.code == 200) {
        this.total = res.total;
        this.tableData = res.rows;
        // this.page = this.total / this.queryInfo.pageSize
        // this.page = parseInt(this.page>1?this.page:"1")
      } else {
        //   this.$message.closeAll();
        //   return this.$message.error(res.msg);
        //   this.resultTitle = "未登录";
        // this.subTitle = "您未登录,请先登录";
        // this.resultShow = true;
      }
    },
    //点击未开始 已结束跳转详情
    goDetail(row) {
      window.sessionStorage.setItem("jjId", row.id);
      this.$router.push("/jjlbxq");
    },
    //点击进行中
    goXuZhi(obj) {
      // if (obj.status == 1) {
      //   this.$message.closeAll();
      //   return this.$message.error("竞价未开始");
      // }
      window.sessionStorage.setItem("jjId", obj.id);
      this.$router.push({
        path: "/jjlbxq",
      });
    },
    //重置
    reset() {
      this.queryInfo = {
        title: null,
        publishCompany: null, //发布单位
        participationMode: null, //参与方式
        beginBeginTime: null, //截止时间
        pageNum: 1,
        pageSize: 10,
        endBeginTime: null,
      };
      this.dateRanger = null;
      this.getLieBiaoData();
    },
    //搜索
    search() {},
    //当前页
    handleCurrentChange(val) {
      this.queryInfo.pageNum = Number(val);
      this.getLieBiaoData();
    },
  },
};
</script>

<style scoped lang="less">
.content_box {
  background: url("../assets/imgs/bg.png") no-repeat;
  padding-bottom: 43px;
}
.content {
  width: 1200px;
  margin: auto;
}
/deep/.el-date-editor .el-range__icon {
  display: none;
}
/deep/.el-date-editor .el-range__close-icon {
  display: none;
}
/deep/.el-date-editor .el-range-separator {
  line-height: 28px;
}
/deep/.el-form-item {
  margin-bottom: 10px;
}
/deep/.el-table__empty-text {
  line-height: 300px;
}
//隔行变色的背景色
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #f3f6fb !important;
}
//表头内边距
/deep/.el-table__header tr.el-table__header th {
  padding: 0 !important;
}
//表格内边距
/deep/.el-table__body tr.el-table__body td {
  padding: 0 !important;
}
//表头单元格右边框
/deep/.el-table th.el-table__cell > .cell {
  border-right: 1px solid #fff;
}
//表格单元格右边框
/deep/.el-table__cell > .cell {
  border-right: 1px solid #95b3db;
}
//取消表头单元格最后一列右边框
/deep/.el-table th.el-table__cell:nth-child(6) > .cell {
  border-right: none;
}
//最后一列不要右边框
/deep/.el-table__cell:last-of-type > .cell {
  border-right: none;
}
//表格下边框
/deep/.el-table td.el-table__cell {
  border-bottom: none;
}
//表单输入框前的文字
/deep/.el-form-item__label {
  padding: 0 !important;
  font-size: 12px !important;
  font-weight: bold;
  color: #3b426b !important;
}
//表单输入框右边距
/deep/.el-input {
  margin-right: 30px !important;
}
//表单输入框内部样式
/deep/.el-input__inner {
  padding: 0 !important;
  height: 30px !important;
  border-radius: 10px !important;
  padding-left: 9px !important;
  border: 1px solid #95b3db !important;
  &::placeholder {
    font-size: 14px !important;
  }
}
//报名时间输入框右侧图标
/deep/.el-icon-date:before {
  content: "\e790";
  color: #95b3db;
  margin-left: 90px;
}
//参与方式输入框右侧图标
/deep/.el-icon-arrow-up:before {
  content: "\e78f";
  color: #95b3db;
}
//重置与搜索按钮样式
.buttonB {
  width: 60px !important;
  height: 30px !important;
  font-size: 14px !important;
  color: #fff !important;
  border-radius: 10px !important;
  padding: 0 !important;
  margin-top: 5px !important;
  line-height: 30px !important;
}
//分页上一页下一页的样式
/deep/.pagination.el-pagination span {
  width: 80px;
  height: 30px;
  border: 1px solid #1c65c4;
  border-radius: 25px;
  color: #3b426b;
  font-weight: bold;
  font-size: 14px;
}
//分页页码颜色
/deep/.pagination.el-pagination li {
  color: #ccd9e9;
}
//分页页码选中之后的颜色
/deep/.pagination.el-pagination li.active {
  color: #3b426b;
}
//分页到第几页输入框右边距
/deep/.el-pagination .el-input {
  margin-right: 0 !important;
  width: 35px;
}
//分页到第几页输入框样式
/deep/.el-pagination .el-input__inner {
  width: 35px;
  height: 30px;
  border: 1px solid #ccd9e9;
  border-radius: 8px;
  padding-left: 0 !important;
}
//确定按钮
.btn {
  width: 80px;
  height: 30px;
  border-radius: 25px;
  background-color: #1c65c4;
  color: #fff;
  text-align: center;
  line-height: 30px;
  margin-left: 24px;
  cursor: pointer;
}
</style>